import getBetweenByOneDate from '../../../../../../helpers/filters/get-between-by-one-date'
import { Filters } from '../../../../../../types/strapi/strapi'
import { ReceiptStatus } from '../../../../../../types/api/receipt'
import FormValues from '../components/filters-form/types/form-values'

const toStatusFilter = (status: string | string[]) =>
    Array.isArray(status) ? { $in: status } : { $eq: status }

export const buildFilters = (
    formValues: Partial<FormValues> = {},
    receiptStatusFilters?: ReceiptStatus[],
    positionFilters: Filters = {}
): Filters => {
    const {
        receiptStatus,
        createdAt,
        arrivalDate,
        materialTypeDocId,
        materialWidth,
        supplierDocId,
    } = formValues

    const selectedStatuses = receiptStatus
        ? Array.isArray(receiptStatus)
            ? receiptStatus
            : [receiptStatus]
        : undefined

    let receiptStatusFilter: ReturnType<typeof toStatusFilter> | undefined
    if (selectedStatuses && receiptStatusFilters) {
        receiptStatusFilter = {
            $in: selectedStatuses.filter(status => receiptStatusFilters.includes(status)),
        }
    } else if (selectedStatuses) {
        receiptStatusFilter = toStatusFilter(selectedStatuses)
    } else if (receiptStatusFilters) {
        receiptStatusFilter = { $in: receiptStatusFilters }
    }

    const receiptFilters: Filters = {
        ...(receiptStatusFilter ? { receiptStatus: receiptStatusFilter } : {}),
        ...(createdAt ? { createdAt: getBetweenByOneDate(createdAt) } : {}),
        ...(arrivalDate ? { estimatedDate: getBetweenByOneDate(arrivalDate) } : {}),
        ...(supplierDocId ? { supplier: { documentId: { $eq: supplierDocId } } } : {}),
    }

    const materialFilters: Record<string, unknown> = {}

    if (materialTypeDocId) {
        materialFilters.material_type = { documentId: { $eq: materialTypeDocId } }
    }

    if (materialWidth != null && materialWidth !== '') {
        const width = Number(materialWidth)
        if (!Number.isNaN(width)) {
            materialFilters.width = { $eq: width }
        }
    }

    return {
        ...positionFilters,
        ...(Object.keys(receiptFilters).length > 0 ? { receipt: receiptFilters } : {}),
        ...(Object.keys(materialFilters).length > 0 ? { material: materialFilters } : {}),
    }
}
